 



import React, { useState } from 'react';
import "./EmployeeRequest.module.css"
const employees = [
  { id: '001', name: 'John Doe' },
  { id: '002', name: 'Jane Smith' },
  { id: '003', name: 'Bob Johnson' },
];

const EmployeeReuqest =() =>{
  const [formData, setFormData] = useState({
    employeeName: '',
    employeeId: '',
    date: '',
    photo: null,
    remarks: '',
    numberOfEmployees: '',
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: type === 'file' ? e.target.files[0] : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.employeeName) {
      newErrors.employeeName = 'Employee name is required';
    }
    if (!formData.employeeId) {
      newErrors.employeeId = 'Employee ID is required';
    }
    if (!formData.date) {
      newErrors.date = 'Date is required';
    }
    if (!formData.numberOfEmployees) {
      newErrors.numberOfEmployees = 'Number of employees is required';
    } else if (isNaN(formData.numberOfEmployees) || formData.numberOfEmployees <= 0) {
      newErrors.numberOfEmployees = 'Please enter a valid number';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      console.log('Form submitted:', formData);
      // Here you would typically send the data to a server
    }
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="employeeName">Employee Name:</label>
          <select
            id="employeeName"
            name="employeeName"
            value={formData.employeeName}
            onChange={handleInputChange}
            className={errors.employeeName ? 'error' : ''}
          >
            <option value="">Select an employee</option>
            {employees.map(emp => (
              <option key={emp.id} value={emp.name}>{emp.name}</option>
            ))}
          </select>
          {errors.employeeName && <span className="error-message">{errors.employeeName}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="employeeId">Employee ID:</label>
          <select
            id="employeeId"
            name="employeeId"
            value={formData.employeeId}
            onChange={handleInputChange}
            className={errors.employeeId ? 'error' : ''}
          >
            <option value="">Select an ID</option>
            {employees.map(emp => (
              <option key={emp.id} value={emp.id}>{emp.id}</option>
            ))}
          </select>
          {errors.employeeId && <span className="error-message">{errors.employeeId}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="date">Date:</label>
          <input
            type="date"
            id="date"
            name="date"
            value={formData.date}
            onChange={handleInputChange}
            className={errors.date ? 'error' : ''}
          />
          {errors.date && <span className="error-message">{errors.date}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="photo">Photo (optional):</label>
          <input
            type="file"
            id="photo"
            name="photo"
            onChange={handleInputChange}
            accept="image/*"
          />
        </div>

        <div className="form-group">
          <label htmlFor="remarks">Remarks (optional):</label>
          <textarea
            id="remarks"
            name="remarks"
            value={formData.remarks}
            onChange={handleInputChange}
          ></textarea>
        </div>

        <div className="form-group">
          <label htmlFor="numberOfEmployees">Number of Employees:</label>
          <input
            type="number"
            id="numberOfEmployees"
            name="numberOfEmployees"
            value={formData.numberOfEmployees}
            onChange={handleInputChange}
            className={errors.numberOfEmployees ? 'error' : ''}
          />
          {errors.numberOfEmployees && <span className="error-message">{errors.numberOfEmployees}</span>}
        </div>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
}


export default EmployeeReuqest